import { render } from "./EmployeeEmergencyContacts.vue?vue&type=template&id=f2414b96&scoped=true"
import script from "./EmployeeEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmployeeEmergencyContacts.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=f2414b96&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2414b96"]])

export default __exports__